export default __webpack_public_path__ + "static/media/cellc_dealerweb.7393abe3.png";